import { Dom, gsap } from '@univers-agency/jupiter'

export default class Popups {
  constructor () {
    const popupTimeline = gsap.timeline()
    Dom.all('[data-popup-trigger]').forEach(t => {
      t.addEventListener('click', () => {
        const target = t.dataset.popupTrigger
        const $target = Dom.find(`[data-popup="${target}"]`)
        if ($target) {
          const $closeButton = Dom.find($target, '[data-popup-close]')
          const $bg = Dom.find($target, '[data-popup-backdrop]')
          const $inner = Dom.find($target, '[data-popup-inner]')
          gsap.set($inner, { opacity: 0, x: -10 })
          gsap.set($bg, { opacity: 0 })
          gsap.set($closeButton, { scale: 0, rotate: 245 })
          gsap.set($target, { display: 'flex' })

          popupTimeline
            .to($bg, { opacity: 0.88, ease: 'sine.in' })
            .to($inner, { opacity: 1 }, '-=0.3')
            .to($inner, { x: 0 }, '<')
            .to($closeButton, { scale: 1, ease: 'back.out(3)', duration: 0.3 })
            .to($closeButton, { rotate: 0, ease: 'back.out(3)', duration: 0.3 }, '<')
        }
      })
    })

    Dom.all('[data-popup-close]').forEach(c => {
      c.addEventListener('click', () => {
        const $target = c.closest('[data-popup]')

        if ($target) {
          const $bg = Dom.find($target, '[data-popup-backdrop]')
          const $inner = Dom.find($target, '[data-popup-inner]')

          popupTimeline
            .to($inner, { opacity: 0, ease: 'sine.in' })
            .to($inner, { x: -15 }, '<')
            .to($bg, { opacity: 0 }, '-=0.3')
            .set($target, { display: 'none' })
        }
      })
    })
  }
}
